import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FiRefreshCw } from "react-icons/fi";
import { LuDownload } from "react-icons/lu";
import { RxHamburgerMenu } from "react-icons/rx";
import { IoMdClose } from "react-icons/io";
import handleGetAllChats from "./apis/handleGetAllChats";
import { Pagination } from "../../../../components";

import ExportChatButton from "./ExportChatButton";

const Chatlogs = ({
  userId,
  botId,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
}) => {
  const [cons, setCons] = useState([]);
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState({});
  const [selectedChat, setSelectedChat] = useState(null);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const fetchChats = async () => {
    const res = await handleGetAllChats(
      userId,
      botId,
      startDate,
      endDate,
      page
    );
    if (!res.error) {
      setCons(res.data);
      setPagination(res.pagination);
      setSelectedChat(res.data?.[0] || null);
    }
  };

  useEffect(() => {
    fetchChats();
  }, [startDate, endDate, page, botId, userId]);

  return (
    <>
      <div className="flex flex-col h-[calc(100vh-100px)] border rounded shadow-md bg-white overflow-hidden">
        {/* Header for Mobile */}
        <div className="md:hidden flex justify-between items-center px-4 py-3 border-b shadow-sm z-20">
          <h1 className="text-lg font-bold text-gray-800">Chat Logs</h1>
          <button onClick={() => setSidebarOpen(true)} className="text-2xl">
            <RxHamburgerMenu />
          </button>
        </div>

        {/* Main Content */}
        <div className="flex flex-1 overflow-hidden">
          {/* Sidebar */}
          <div
            className={`fixed md:static z-30 md:z-10 top-0 left-0 h-full w-3/4 sm:w-2/5 md:w-1/3 bg-white border-r shadow-md p-4 transition-transform duration-300 ease-in-out ${
              sidebarOpen ? "translate-x-0" : "-translate-x-full"
            } md:translate-x-0`}>
            <div className="md:hidden flex justify-between items-center mb-4">
              <h2 className="text-lg font-bold">Chat Logs</h2>
              <button
                onClick={() => setSidebarOpen(false)}
                className="text-gray-600 hover:text-black text-xl">
                <IoMdClose />
              </button>
            </div>

            <div className="hidden md:flex justify-between items-center mb-4">
              <h2 className="text-xl font-bold text-gray-800">Chat Logs</h2>
              <button
                onClick={fetchChats}
                className="text-gray-600 hover:text-black"
                title="Refresh">
                <FiRefreshCw />
              </button>
            </div>

            {/* Filters */}
            <div className="flex flex-col sm:flex-row gap-2 mb-4">
              <DatePicker
                selected={startDate}
                onChange={(date) => setStartDate(date)}
                selectsStart
                startDate={startDate}
                endDate={endDate}
                placeholderText="Start Date"
                className="border px-3 py-2 rounded-md shadow-sm text-sm w-full"
              />
              <DatePicker
                selected={endDate}
                onChange={(date) => setEndDate(date)}
                selectsEnd
                startDate={startDate}
                endDate={endDate}
                minDate={startDate}
                placeholderText="End Date"
                className="border px-3 py-2 rounded-md shadow-sm text-sm w-full"
              />
            </div>

            {/* <button
              className="flex items-center justify-center w-full gap-2 px-4 py-2 border rounded-md bg-gray-100 hover:bg-gray-200 text-gray-700 mb-4"
              title="Export Chat Logs"
              onClick={() => exportToPDF(cons)}>
              <LuDownload /> Export
            </button> */}
            <ExportChatButton cons={cons} />

            {/* Chat List */}
            {cons.length === 0 ? (
              <div className="text-center text-gray-500 h-48 flex items-center justify-center">
                No chats found.
              </div>
            ) : (
              <div className="overflow-y-auto space-y-2 pr-1 max-h-[calc(100vh-300px)]">
                {cons.map((chat, idx) => (
                  <div
                    key={chat.uuid + idx}
                    onClick={() => {
                      setSelectedChat(chat);
                      setSidebarOpen(false);
                    }}
                    className={`cursor-pointer p-3 rounded-md border hover:shadow transition ${
                      selectedChat?.uuid === chat.uuid
                        ? "bg-gray-200 border-gray-400"
                        : "bg-white"
                    }`}>
                    <div className="font-semibold text-sm text-gray-700 mb-1">
                      {chat.name || "Unknown User"}
                    </div>
                    <div className="text-xs text-gray-500 truncate">
                      {chat.email || "N/A"}
                    </div>
                    <div className="text-xs text-gray-400">
                      {chat.city || "Unknown"}, {chat.country || "N/A"}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Overlay on Mobile */}
          {sidebarOpen && (
            <div
              onClick={() => setSidebarOpen(false)}
              className="fixed inset-0 bg-black bg-opacity-30 z-20 md:hidden"></div>
          )}

          {/* Chat Panel */}
          <div className="w-full md:w-2/3 flex flex-col h-full">
            <div className="p-4 border-b flex flex-col md:flex-row justify-between gap-2 items-start md:items-center">
              <div className="text-lg font-bold text-gray-800">
                Chat with {selectedChat?.name || selectedChat?.email || "User"}
              </div>
            </div>

            {selectedChat && (
              <div className="flex flex-col md:flex-row justify-between mb-2 px-4 py-2 bg-gray-100 text-sm text-gray-600 border-b gap-2">
                <div>
                  <span className="font-semibold">Location:</span>{" "}
                  {selectedChat.city || "N/A"}, {selectedChat.country || "N/A"}
                </div>
                <div>
                  <span className="font-semibold">User:</span>{" "}
                  {selectedChat.name || "Unknown"} |{" "}
                  {selectedChat.email || "N/A"} | {selectedChat.phone || "N/A"}
                </div>
                <div>
                  <span className="font-semibold">RAG Quality:</span>{" "}
                  {selectedChat.rag_quality_count ?? "N/A"}
                </div>
              </div>
            )}

            <div className="flex-1 overflow-y-auto p-4 bg-white">
              {!selectedChat ? (
                <div className="text-gray-400 text-center mt-20">
                  Select a chat to view messages
                </div>
              ) : (
                selectedChat.ques?.map((q, i) => (
                  <div key={i} className="mb-6">
                    <div className="mb-2 flex justify-start">
                      <div className="bg-blue-100 text-blue-800 p-3 rounded-xl max-w-lg shadow-sm">
                        <span className="font-medium">User:</span> {q}
                      </div>
                    </div>
                    <div className="flex justify-end">
                      <div className="bg-green-100 text-green-800 p-3 rounded-xl max-w-lg shadow-sm">
                        <span className="font-medium">Bot:</span>{" "}
                        {selectedChat.answer?.[i]?.trim() || "No response."}
                      </div>
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>
        </div>
      </div>
      {/* Pagination for Sidebar */}
      {pagination.totalPages > 1 && (
        <div className="mt-4">
          <Pagination
            currentPage={pagination.currentPage}
            totalPages={pagination.totalPages}
            onPageChange={(newPage) => setPage(newPage)}
          />
        </div>
      )}
    </>
  );
};

export default Chatlogs;
